module.exports = __webpack_public_path__ + "static/oprah-winfrey-logo-2ce10c5ae0667255e4e094480b7ff9d0.png";